import { MDNewsItem } from "@/models/News";
import { LanCode } from "@/store/reducers/setting";
import { PageSeoData } from "@/types/seo";
import { SEO_CONSTANTS } from "../constants";

/**
 * 뉴스 상세 페이지 SEO 생성기
 */
export function generateNewsSeo(
  news: MDNewsItem,
  locale: LanCode,
): PageSeoData {
  const description =
    news.summary?.slice(0, 160) || `${news.title} - Latest news from bHaptics`;

  const thumbnailUrl = news.thumbnailSrc || "";
  const ogImage = thumbnailUrl || SEO_CONSTANTS.DEFAULT_OG_IMAGE;
  const imageUrl =
    thumbnailUrl ||
    `${SEO_CONSTANTS.BASE_URL}${SEO_CONSTANTS.DEFAULT_OG_IMAGE}`;

  return {
    title: `${news.title} | bHaptics News`,
    description,
    ogImage,
    ogType: "article",
    canonicalPath: `/news/${news.id}`,
    publishedTime: news.date,
    keywords: [news.category, "bHaptics", "news", "haptic"],
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "NewsArticle",
        headline: news.title,
        description: news.summary || null,
        image: imageUrl,
        datePublished: news.date || null,
        author: {
          "@type": "Organization",
          name: news.source || "bHaptics",
        },
        publisher: {
          "@type": "Organization",
          name: "bHaptics",
          logo: {
            "@type": "ImageObject",
            url: `${SEO_CONSTANTS.BASE_URL}/images/logo.png`,
          },
        },
        mainEntityOfPage: {
          "@type": "WebPage",
          "@id": `${SEO_CONSTANTS.BASE_URL}/${locale}/news/${news.id}`,
        },
      },
    ],
  };
}

/**
 * 블로그 상세 페이지 SEO 생성기
 * (Notion 블록 기반)
 */
export interface BlogSeoInput {
  id: string;
  title: string;
  description?: string;
  coverImage?: string;
  createdTime?: string;
  lastEditedTime?: string;
}

export function generateBlogSeo(blog: BlogSeoInput): PageSeoData {
  const description =
    blog.description?.slice(0, 160) ||
    `${blog.title} - Read more on bHaptics blog`;

  return {
    title: `${blog.title} | bHaptics Blog`,
    description,
    ogImage: blog.coverImage || SEO_CONSTANTS.DEFAULT_OG_IMAGE,
    ogType: "article",
    canonicalPath: `/blog/${blog.id}`,
    publishedTime: blog.createdTime,
    modifiedTime: blog.lastEditedTime,
    keywords: ["bHaptics", "blog", "haptic", "VR"],
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        headline: blog.title,
        description: blog.description || null,
        image:
          blog.coverImage ||
          `${SEO_CONSTANTS.BASE_URL}${SEO_CONSTANTS.DEFAULT_OG_IMAGE}`,
        datePublished: blog.createdTime || null,
        dateModified: blog.lastEditedTime || null,
        author: {
          "@type": "Organization",
          name: "bHaptics",
        },
        publisher: {
          "@type": "Organization",
          name: "bHaptics",
          logo: {
            "@type": "ImageObject",
            url: `${SEO_CONSTANTS.BASE_URL}/images/logo.png`,
          },
        },
      },
    ],
  };
}
